import { render } from "./CatalogoEmpregador.vue?vue&type=template&id=2614ee5f&ts=true"
import script from "./CatalogoEmpregador.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogoEmpregador.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src-next/modulos/estrutura-de-ponto-da-empresa/empregador/catalogo/apresentacao/CatalogoEmpregador.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2614ee5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2614ee5f', __exports__)) {
    api.reload('2614ee5f', __exports__)
  }
  
  module.hot.accept("./CatalogoEmpregador.vue?vue&type=template&id=2614ee5f&ts=true", () => {
    api.rerender('2614ee5f', render)
  })

}


export default __exports__